import { css } from "../../../styled-system/css";

export const styles = {
  section: css({
    py: "baseUnit.mobile7",
    backgroundColor: "white",
    width: "100%",
  }),
  inner: css({
    display: "flex",
    flexDirection: "column",
    gap: "baseUnit.mobile3",
    alignItems: "center",
    width: "100%",
  }),
  headingBlock: css({
    display: "flex",
    flexDirection: "column",
    gap: "baseUnit.mobile1",
    width: "100%",
  }),
  heading: css({
    margin: 0,
    fontSize: "heading.H2.desktop",
    lineHeight: "heading.H2.desktop",
    letterSpacing: "heading.H2.desktop",
  }),
  subtitle: css({
    fontSize: "body.cat",
    fontWeight: 400,
    lineHeight: "body.cat",
    letterSpacing: "body.cat",
    color: "headlineGrey",
    margin: 0,
  }),
  table: css({
    display: "table",
    width: "100%",
    borderCollapse: "separate",
    borderSpacing: "4px",
    desktop: {
      tableLayout: "fixed",
    },
  }),
  dataCol: css({
    width: "100px",
    desktop: {
      width: "auto",
    },
  }),
  headerCell: css({
    display: "table-cell",
    verticalAlign: "middle",
    py: "baseUnit.mobile2",
    textAlign: "center",
    overflow: "hidden",
    px: "baseUnit.mobile1",
    "&[data-label]": {
      textAlign: "left",
      backgroundColor: "backgroundGrey",
      desktop: {
        px: "baseUnit.mobile3",
      },
    },
    "&[data-carfax]": {
      backgroundColor: "linkBlue",
    },
    "&[data-other]": {
      backgroundColor: "warmGrey",
    },
  }),
  headerText: css({
    fontSize: "body.cat",
    fontWeight: 700,
    lineHeight: "body.cat",
    letterSpacing: "body.cat",
    color: "headlineGrey",
    desktop: {
      fontSize: "body.horse",
      lineHeight: "body.horse",
      letterSpacing: "body.horse",
    },
    "&[data-inverted]": {
      color: "white",
    },
  }),
  carfaxLogo: css({
    width: "76px",
    height: "14px",
    display: "inline-block",
    desktop: {
      width: "131px",
      height: "24px",
    },
  }),
  bodyCell: css({
    display: "table-cell",
    verticalAlign: "middle",
    py: "baseUnit.mobile2",
    textAlign: "center",
    overflow: "hidden",
    "&[data-label]": {
      textAlign: "left",
      px: "baseUnit.mobile1",
      borderBottom: "1px solid",
      borderBottomColor: "disabledGrey",
      desktop: {
        px: "baseUnit.mobile3",
      },
    },
    "&[data-label][data-last]": {
      border: "none",
    },
    "&[data-highlighted]": {
      backgroundColor: "babyBlue.transparent",
    },
    "&[data-muted]": {
      backgroundColor: "disabledGrey",
    },
  }),
  cellContent: css({
    display: "flex",
    alignItems: "center",
    gap: "baseUnit.mobile1",
  }),
  rowIcon: css({
    display: "none",
    desktop: {
      display: "block",
      width: "baseUnit.mobile3",
      height: "baseUnit.mobile3",
      flexShrink: 0,
    },
  }),
  cellText: css({
    fontSize: "body.cat",
    fontWeight: 400,
    lineHeight: "body.cat",
    letterSpacing: "body.cat",
    color: "headlineGrey",
    desktop: {
      fontSize: "body.horse",
      lineHeight: "body.horse",
      letterSpacing: "body.horse",
    },
  }),
  dataValueWrapper: css({
    display: "flex",
    gap: "4px",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "heading.H4.mobile",
    fontWeight: 700,
    lineHeight: "heading.H4.mobile",
    color: "headlineGrey",
    whiteSpace: "nowrap",
    desktop: {
      fontSize: "heading.H4.desktop",
      lineHeight: "heading.H4.desktop",
      gap: "10px",
      "& span": {
        fontSize: "heading.H4.desktop",
      },
    },
    "& span[data-muted]": {
      color: "borderGrey",
    },
  }),
};
